import { IonPage, IonSpinner } from '@ionic/react';
import { useEffect, useState } from 'react';
import { useHistory } from 'react-router';

import ErrorModal from '@/assets/imgs/password-error.svg';
import SuccessModal from '@/components/common/SucessModal';
import { ROUTES_PATH } from '@/constants';
import useModal from '@/hooks/useModal';
import {
  EcommercePlatform, EcommerceWidget,
} from '@/interfaces/PluginInterface/PluginInterface';
import {
  getPlatform, getWidget, postWidget, updateWidget,
} from '@/redux/ecommerceWidget/ecommerceWidgetAPI';

import EcommerceData from './EcommerceData/EcommerceData';
import styles from './Plugin.module.scss';
import PluginConfig from './PluginConfig/PluginConfig';

export default function Plugin() {
  const [platformData, setPlatformData] = useState<EcommercePlatform | undefined>(undefined);
  let platform: string;
  const [widgetData, setWidgetData] = useState<EcommerceWidget | undefined>(undefined);
  const [isWidgetChanged, setIsWidgetChanged] = useState<boolean>(false);
  const [isLoading, setisLoading] = useState<boolean>(false);
  const [refreshData, setRefreshData] = useState<boolean>(false);
  const [widget404, setWidget404] = useState<boolean>(false);
  const { presentModal: presentSuccessModal } = useModal(SuccessModal);
  const history = useHistory();

  const handleWidgetUpdate = async (newWidgetData: EcommerceWidget) => {
    setisLoading(true);
    try {
      const resultWidgetData = await updateWidget(newWidgetData);
      if (resultWidgetData) {
        setisLoading(false);
        setWidgetData(resultWidgetData);

        presentSuccessModal({
          message: 'Se han guardado los cambios',
          title: '',
          modalSize: true,
          txtButton: 'Continuar',
          padding: '10px',
          onDismiss: () => {
            history.push(ROUTES_PATH.PLUGIN);
          },
        });
      }
    } catch (error: any) {
      setisLoading(false);
      presentSuccessModal({
        message: 'Ha ocurrido un error al guardar los cambios',
        title: '',
        srcImage: ErrorModal,
        modalSize: true,
        txtButton: 'Volver',
        padding: '20px',
        onDismiss: () => {
          history.push(ROUTES_PATH.OPERATION_DASHBOARD);
        },
      });
    }
  };

  const initialize = async () => {
    setWidget404(false);
    setisLoading(true);
    try {
      const platformResponse = await getPlatform();
      setPlatformData(platformResponse.data);
      platform = platformResponse.data.platform || '';
      try {
        const widgetResponse = await getWidget();
        setWidgetData(widgetResponse.data);
        setisLoading(false);
      } catch (error: any) {
        if (error.result.http_code === 404) {
          setWidget404(true);
        }
        setisLoading(false);
      }
    } catch (error: any) {
      setisLoading(false);
    }
  };
  const handleWidget = async (changeWidget: boolean, platform_id: string) => {
    if (!widget404) {
      return;
    }
    setIsWidgetChanged(changeWidget);
    const platformPost = platform_id || platform || platformData?.platform;
    // alert(platformPost);

    const postWidgetPlatformData = {
      platform: platformPost,
    };
    // alert(JSON.stringify(postWidgetPlatformData));

    try {
      const postWidgetPlatform = await postWidget(postWidgetPlatformData);
      if (postWidgetPlatform.result.http_code === 200) {
        setRefreshData(true);
      }
    } catch (error: any) {
      console.error('Error al ejecutar handleWidget:', error);
    }
  };
  const setLoadingState = (loading: boolean) => {
    setisLoading(loading);
  };

  useEffect(() => {
    initialize();
  }, [refreshData]);

  return (
    <IonPage className={styles.pluginPage}>
      {isLoading && (
        <div className={styles.reportingLoadingContainer}>
          <div className={styles.customSpinner}>
            <IonSpinner
              color="danger"
              name="bubbles"
              className={styles.scrollSpinner}
            />
            <span className={styles.spinnerText}>Cargando...</span>
          </div>
        </div>
      )}
      {!isLoading && (
        <>
          <EcommerceData platformData={platformData} handleWidget={handleWidget} setLoadingState={setLoadingState} />
          {widgetData != undefined && (
            <PluginConfig widgetData={widgetData} updateWidgetData={(data: any) => handleWidgetUpdate(data)} />
          )}
        </>
      )}
    </IonPage>
  );
}
